module.exports = __webpack_public_path__ + "img/D201805_7.3765b513.jpg";